import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

// components
import PrivateRoute from './PrivateRoute';
import Root from './Root';
import { profile } from 'console';

// lazy load all the views


// auth
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const Confirm = React.lazy(() => import('../pages/auth/Confirm'));
const ForgetPassword = React.lazy(() => import('../pages/auth/ForgetPassword'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const LockScreen = React.lazy(() => import('../pages/auth/LockScreen'));

// HelpDash
const HelpDash = React.lazy(() => import('../pages/helpDash'));

// Profile
const Profile = React.lazy(() => import('../pages/profile'));

// landing
const Landing = React.lazy(() => import('../pages/landing/'));

// dashboard
const DashboardPage = React.lazy(() => import('../pages/dashboard/DashboardPage/'));

// form
const FormPage = React.lazy(() => import('../pages/form/FormPage/'));

const PublicDashboardPage = React.lazy(() => import('../pages/dashboard/PublicDashboardPage/'));

const SlideShowDashboardPage = React.lazy(() => import('../pages/dashboard/SlidShowDashboardPage/'));

// - adminSettings
const FormManagement = React.lazy(() => import('../pages/adminSettings/Rahbari/Form/FormManagement'));
const UserManagement = React.lazy(() => import('../pages/adminSettings/Rahbari/User/UserManagement'));
const RoleManagement = React.lazy(() => import('../pages/adminSettings/Rahbari/Role/RoleManagement'));
const FeedbackList = React.lazy(() => import('../pages/adminSettings/Rahbari/Feedback/FeedbackList'));
const ChartManagment = React.lazy(() => import('../pages/adminSettings/Chart/ChartManagment'));
const FormManagment = React.lazy(() => import('../pages/adminSettings/Form/FormManagment'));

const DataSourceManagment = React.lazy(() => import('../pages/adminSettings/DataSource/DataSourceManagment'));
const SazmanManagment = React.lazy(() => import('../pages/adminSettings/Sazman/SazmanManagment'));

const DataSourceRelationManagment = React.lazy(() => import('../pages/adminSettings/DataSource/DatasourceRelation/DataSourceRelationManagment'));
const DataSourceRelationDesigner = React.lazy(() => import('../pages/adminSettings/DataSource/DatasourceRelation/DataSourceRelationDesigner'));
const SettingAll = React.lazy(() => import('../pages/adminSettings/Settings/SettingAll'));
const SettingUI = React.lazy(() => import('../pages/adminSettings/Settings/SettingUI'));
const SettingRadio = React.lazy(() => import('../pages/adminSettings/Settings/Radio/SettingRadio'));
const Menu = React.lazy(() => import('../pages/adminSettings/Settings/Menu/Menu'));
const Backup = React.lazy(() => import('../pages/adminSettings/Settings/Backup/Backup'));

const ChartDesigner = React.lazy(() => import('../pages/adminSettings/ChartDesigner'));
const FormBuilder = React.lazy(() => import('../pages/adminSettings/FormBuilder'));
const WorkflowDesigner = React.lazy(() => import('../pages/adminSettings/WorkflowDesigner'));


// extra pages
const Error404 = React.lazy(() => import('../pages/error/Error404'));
const Error500 = React.lazy(() => import('../pages/error/Error500'));
const AccessDenied = React.lazy(() => import('../pages/error/AccessDenied'));
const NotDefaultPage = React.lazy(() => import('../pages/error/NotDefaultPage'));
const ActivateLicense = React.lazy(() => import('../pages/error/ActivateLicense'));



export interface RoutesProps {
    path: RouteProps['path'];
    name?: string;
    component?: RouteProps['component'];
    route?: any;
    exact?: RouteProps['exact'];
    icon?: string;
    header?: string;
    roles?: string[];
    requiredScopes?: string[];
    children?: RoutesProps[];
}

// root routes
const rootRoute: RoutesProps = {
    path: '/',
    exact: true,
    component: () => <Root />,
    route: Route,
};


// dashboards
const dashboardRoutes: RoutesProps = {
    path: '/dashboard',
    name: 'Dashboards',
    icon: 'airplay',
    header: 'Navigation',
    children: [        
        {
            path: '/dashboard/dashboardPage/:id',
            name: 'DashboardPage',
            component: DashboardPage,
            //requiredScopes:
            route: PrivateRoute,
        },
        {
            path: '/ShareLink/:id',
            name: 'PublicDashboardPage',
            component: PublicDashboardPage,
            //requiredScopes:
            route: Route,
        },
        {
            path: '/dashboard/SlideShowDashboardPage/:id',
            name: 'SlideShowDashboardPage',
            component: SlideShowDashboardPage,
            //requiredScopes:
            route: Route,
        }
        
    ],
};

// forms
const formsRoutes: RoutesProps = {
    path: '/form',
    name: 'FormPage',
    icon: 'airplay',
    header: 'Navigation',
    children: [        
        {
            path: '/form/formPage/:id',
            name: 'FormPage',
            component: FormPage,
            //requiredScopes:
            route: PrivateRoute,
        }        
    ],
};


// adminSettings
const adminSettingsRoutes: RoutesProps = {
    path: '/adminSettings',
    name: 'adminSettings',
    icon: 'package',
    header: 'Custom',
    children: [
        {
            path: '/formBuilder',
            name: 'formBuilder',
            component:FormBuilder,
            route: PrivateRoute,
        },
        {
            path: '/chartDesigner',
            name: 'chartDesigner',
            component:ChartDesigner,
            route: PrivateRoute,
        },

        {
            path: '/workflowDesigner',
            name: 'workflowDesigner',
            component:WorkflowDesigner,
            route: PrivateRoute,
        },        
        
        {
            path: '/adminSettings/rahbari/feedback',
            name: 'feedbackList',
            component: FeedbackList,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/rahbari/formManagement',
            name: 'formManagement',
            component: FormManagement,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/rahbari/userManagement',
            name: 'userManagement',
            component: UserManagement,
            //roles: ['Admin'],
            //requiredScopes:['Permissions.Product.View','Permissions.Product.New','Permissions.Product.View2'],
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/rahbari/roleManagement',
            name: 'roleManagement',
            component: RoleManagement,
            //requiredScopes:['55BAE434-1CA3-ED11-AC34-000AEB4BFDC5'],

            route: PrivateRoute,
        },
        
        {
            path: '/adminSettings/chart/chartManagment',
            name: 'chartManagment',
            component: ChartManagment,
            route: PrivateRoute,
        },        
        {
            path: '/adminSettings/form/formManagment',
            name: 'formManagment',
            component: FormManagment,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/datasource/dataSourceManagment',
            name: 'dataSourceManagment',
            component: DataSourceManagment,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/sazman/sazmanManagment',
            name: 'sazmanManagment',
            component: SazmanManagment,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/datasource/dataSourceRelation',
            name: 'dataSourceRelation',
            component: DataSourceRelationManagment,
            route: PrivateRoute,
        },        
        {
            path: '/adminSettings/datasource/DataModel',
            name: 'dataSourceRelation',
            component: DataSourceRelationDesigner,
            route: PrivateRoute,
        },
        
        {
            path: '/adminSettings/settings/settingUI',
            name: 'settingUI',
            component: SettingUI,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/settings/settingAll',
            name: 'settingAll',
            component: SettingAll,
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/settings/settingRadio',
            name: 'settingRadio',
            component: SettingRadio,
            //requiredScopes:['D72986DE-675F-EE11-AFFD-08606E00EBAA'],
            route: PrivateRoute,
        },
        {
            path: '/adminSettings/settings/menu',
            name: 'menu',
            component: Menu,
            route: PrivateRoute,
        },        
        {
            path: '/adminSettings/settings/backup',
            name: 'backup',
            component: Backup,
            route: PrivateRoute,
        }
    ],
};

const extrapagesRoutes: RoutesProps[] = 
    [
        {
            path: '/Account/profile',
            name: 'Profile',
            component: Profile,
            route: PrivateRoute,
        },
        {
            path: '/Help',
            name: 'Help',
            component: HelpDash,
            route: PrivateRoute,
        }
    ];





// auth
const authRoutes: RoutesProps[] = [
    {
        path: '/auth/login',
        name: 'Login',
        component: Login,
        route: Route,
    },
    {
        path: '/auth/register',
        name: 'Register',
        component: Register,
        route: Route,
    },
    {
        path: '/auth/confirm',
        name: 'Confirm',
        component: Confirm,
        route: Route,
    },
    {
        path: '/auth/forget-password',
        name: 'Forget Password',
        component: ForgetPassword,
        route: Route,
    },
    {
        path: '/auth/lock-screen',
        name: 'Lock Screen',
        component: LockScreen,
        route: Route,
    },
    {
        path: '/auth/logout',
        name: 'Logout',
        component: Logout,
        route: Route,
    },
];

// public routes
const otherPublicRoutes: RoutesProps[] = [
    {
        path: '/landing',
        name: 'landing',
        component: Landing,
        route: Route,
    },
    
    {
        path: '/not-found',
        name: 'Error - 404',
        component: Error404,
        route: Route,
    },
    {
        path: '/access-denied',
        name: 'Error - AccessDenied',
        component: AccessDenied,
        route: Route,
    },    
    {
        path: '/notSetDefaultPage',
        name: 'Error - NotSetDefaultPage',
        component: NotDefaultPage,
        route: Route,
    },    
    {
        path: '/error-500',
        name: 'Error - 500',
        component: Error500,
        route: Route,
    },
    {
        path: '/license',
        name: 'License',
        component: ActivateLicense,
        route: Route,
    },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
    let flatRoutes: RoutesProps[] = [];

    routes = routes || [];
    routes.forEach((item: RoutesProps) => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const authProtectedRoutes = [rootRoute, dashboardRoutes,formsRoutes, adminSettingsRoutes,...extrapagesRoutes];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export { publicRoutes, authProtectedRoutes, authProtectedFlattenRoutes, publicProtectedFlattenRoutes };
